import { render, staticRenderFns } from "./AppIconButton.vue?vue&type=template&id=7a5e8483&scoped=true&"
import script from "./AppIconButton.vue?vue&type=script&lang=js&"
export * from "./AppIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5e8483",
  null
  
)

export default component.exports